var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button outlined",attrs:{"href":"#social"},on:{"click":_vm.onClickAnchor}},[_vm._v(_vm._s(_vm.$c('Поделиться')))])}
var staticRenderFns = []

export { render, staticRenderFns }